export const SELF_SERVE_BILLING_CYCLES = {
  MONTHLY: '30 day',
  ANNUAL: '365 day',
} as const;

export const NON_SELF_SERVE_BILLING_CYCLES = {
  QUARTERLY: '90 day',
  SEMI_ANNUAL: '180 day',
} as const;

// Get billing cycle options for self-serve customers (used by radio inputs)
export const getAllBillingCycleOptions = () => {
  return Object.values(SELF_SERVE_BILLING_CYCLES).map((cycle) => ({
    value: cycle,
    label: cycle,
  }));
};
